import { render, staticRenderFns } from "./hi-exclusions.vue?vue&type=template&id=58326157&scoped=true"
import script from "./hi-exclusions.vue?vue&type=script&lang=js"
export * from "./hi-exclusions.vue?vue&type=script&lang=js"
import style0 from "./hi-exclusions.vue?vue&type=style&index=0&id=58326157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58326157",
  null
  
)

export default component.exports